import { SxProps, Theme } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { get } from 'lodash-es';
import React, { useCallback } from 'react';
import {
  Control,
  Controller,
  FieldErrors,
  FieldPath,
  FieldValues,
  useController,
} from 'react-hook-form';

interface CheckBoxGroupFormFieldProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  errors?: FieldErrors<TFieldValues>;
  name: string;
  options: Array<{ label: string; value: string }>;
  sx?: SxProps<Theme>;
}
export const CheckBoxGroupFormField = <TFieldValues extends FieldValues = FieldValues>({
  control,
  errors,
  name,
  options,
  sx,
}: CheckBoxGroupFormFieldProps<TFieldValues>) => {
  const controller = useController({
    control,
    name: name as FieldPath<TFieldValues>,
  });

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked, value } = event.target;
      const checkedItems = (controller.field.value || []) as string[];
      let newCheckedItems = [...checkedItems] as string[];

      if (checked) {
        newCheckedItems.push(value);
      } else {
        newCheckedItems = newCheckedItems.filter((item) => item !== value);
      }

      controller.field.onChange(newCheckedItems);
    },
    [controller.field],
  );

  return (
    <Controller
      name={name as FieldPath<TFieldValues>}
      control={control}
      render={() => {
        return (
          <FormControl component="fieldset" error={Boolean(get(errors, name))} sx={sx}>
            <FormGroup>
              {options.map((option) => {
                const checkedItems = (controller.field.value || []) as string[];

                return (
                  <FormControlLabel
                    key={option.value}
                    label={option.label}
                    control={
                      <Checkbox
                        checked={checkedItems.includes(option.value)}
                        onChange={handleChange}
                        value={option.value}
                      />
                    }
                  />
                );
              })}
            </FormGroup>
          </FormControl>
        );
      }}
    />
  );
};
